import { FormBase } from 'core/components';

export default class ExistingPatientDataForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'patientId',
                    label: 'FACILITY_ORDER_TEMPLATE.CREATE_PATIENT.PATIENT_ID',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.CREATE_PATIENT.PATIENT_ID',
                    rules: 'required|string'                
                },
                {
                    name: 'subCategoryId',
                    label: 'FACILITY_ORDER_TEMPLATE.NEW_FACILITY_ORDER_TEMPLATE.SUB_CATEGORY_NAME_LABEL',
                    placeholder: 'FACILITY_ORDER_TEMPLATE.NEW_FACILITY_ORDER_TEMPLATE.SUB_CATEGORY_NAME_PLACEHOLDER',
                    rules: 'required|string'                
                },
                {
                    name: 'eligibilityStatusId',
                    label: 'Eligibility Status',
                    placeholder: 'Select Eligibility Status',
                    rules: 'required'
                },
            ],
        };
    }
}
